<div class="support-assign-form" [class.disabled]="disabled()">
    <div>
        <h2>Terminvorschlag zuweisen</h2>
        <p style="margin-top: 4px;">Datum & Uhrzeit: <b>{{ appointmentRequest().date | date:'dd.MM.yyyy HH:mm' }}</b></p>
    </div>
    
    <div class="form-actions">
        <afs-button type="outline" color="danger" (click)="appointmentRejectModal.show()">Vorschlag ablehnen</afs-button>
        <afs-button (click)="appointmentAssignModal.show()">Akzeptieren & Zuweisen</afs-button>
        <afs-button (click)="openCalendar()" type="outline" iconName="fa-calendar" [iconOnly]="true" afsTooltip="Kalender"></afs-button>
    </div>
</div>



<afs-modal #appointmentRejectModal title="Terminvorschlag ablehnen" [maxWidth]="450" (onClose)="assignRejectContent.clear()">
    <appointment-assign-reject #assignRejectContent></appointment-assign-reject>
    <div class="afs-modal-footer">
        @if(assignRejectContent.form.get("withNewAppointment")?.value === "1"){
            <afs-button [disabled]="assignRejectContent.disabled" [fullWidth]="true" (click)="rejectAppointmentRequest(assignRejectContent.appointmentRequestOptions)">Terminvorschlag senden</afs-button>
        }@else{
            <afs-button [fullWidth]="true" color="danger" (click)="rejectAppointmentRequest(assignRejectContent.appointmentRequestOptions)">Terminvorschlag ablehnen</afs-button>
        }
    </div>
</afs-modal>

<afs-modal #appointmentAssignModal title="Terminvorschlag zuweisen" [maxWidth]="450" (onClose)="assignAcceptContent.clear()">
    <appointment-assign-accept #assignAcceptContent></appointment-assign-accept>
    <div id="appointment-assign-footer" class="afs-modal-footer">
        <afs-button [fullWidth]="true" [disabled]="assignAcceptContent.disabled" (click)="acceptAppointmentRequest(assignAcceptContent.appointmentRequestOptions)">Akzeptieren & Zuweisen</afs-button> 
    </div>
</afs-modal>